<script setup lang="ts">
import { Plus } from 'lucide-vue-next';

import AzureIcon from '@/assets/azure.svg';
import { Button } from '@/components/ui/button';
import { useConfigCatStore } from '@/stores/configCat';

const configCatStore = useConfigCatStore();

interface Emits {
    (e: 'create-group'): void;
    (e: 'view-azure-groups'): void;
}

defineEmits<Emits>();
</script>

<template>
    <div class="text-center py-12">
        <h3 class="font-semibold text-lg mb-2">No user groups yet</h3>
        <p v-if="configCatStore.azureGroups" class="text-muted-foreground mb-4">
            Get started by <strong>creating</strong> or
            <strong>importing</strong> your first user group.
        </p>
        <p v-else class="text-muted-foreground mb-4">
            Get started by creating your first user group.
        </p>
        <div class="flex items-center justify-center space-x-4">
            <Button @click="$emit('create-group')">
                <Plus class="w-4 h-4 mr-2" />
                Create First Group
            </Button>
            <Button
                v-if="configCatStore.azureGroups"
                @click="$emit('view-azure-groups')"
                variant="outline"
            >
                <img :src="AzureIcon" class="w-4 h-4 mr-2" alt="Azure" />
                Import from Azure AD Groups
            </Button>
        </div>
    </div>
</template>
